import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import SVGMicrowave from '../svg/SVGMicrowave';
import SVGStove from '../svg/SVGStove';
import SVGDishwasher from '../svg/SVGDishwasher';
import SVGWashing from '../svg/SVGWashing';
import SVGFreezer from '../svg/SVGFreezer';
import SVGRefrigerator from '../svg/SVGRefrigerator';
import SVGComputer from '../svg/SVGComputer';
import SVGRouter from '../svg/SVGRouter';
import SVGPhone from '../svg/SVGPhone';
import SVGLights from '../svg/SVGLights';

export default function I() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.I');
    const iconsLists: any = [
        {
            id: 1,
            text: t('icon1'),
            icon: <SVGMicrowave />,
        },
        {
            id: 2,
            text: t('icon2'),
            icon: <SVGStove />,
        },
        {
            id: 3,
            text: t('icon3'),
            icon: <SVGDishwasher />,
        },
        {
            id: 4,
            text: t('icon4'),
            icon: <SVGWashing />,
        },
        {
            id: 5,
            text: t('icon5'),
            icon: <SVGFreezer />,
        },
        {
            id: 6,
            text: t('icon6'),
            icon: <SVGRefrigerator />,
        },
        {
            id: 7,
            text: t('icon7'),
            icon: <SVGComputer />,
        },
        {
            id: 8,
            text: t('icon8'),
            icon: <SVGRouter />,
        },
        {
            id: 9,
            text: t('icon9'),
            icon: <SVGPhone />,
        },
        {
            id: 10,
            text: t('icon10'),
            icon: <SVGLights />,
        },
    ];

    return (
        <div className={`power-ocean-home-I ${styles['power-ocean-home-I']}`}>
            <div className="sec9">
                <p className="title">{t('title')}</p>
                <p className="desc">{t('desc')}</p>
                <div className="icon-list">
                    {iconsLists.map((item: any) => (
                        <div className="icon-item" key={item.id}>
                            <div className="icon">{item.icon}</div>
                            <p className="text">{item.text}</p>
                        </div>
                    ))}
                </div>
            </div>
            <div className="black-bg"></div>
        </div>
    );
}
